import axios from 'axios';
import routes from './routes';

export const buscarCNPJ = q => (
  axios.get(routes.simuladores.buscarCNPJ(q))
);

export const buscarEmpresa = q => (
  axios.get(routes.simuladores.buscarEmpresa(q))
);

export const fetchDefaultParametros = () => (
  axios.get(routes.simuladores.fetchDefaultParametros())
);

export const getCativoInfo = cnpj => (
  axios.get(routes.simuladores.getCativoInfo(cnpj))
);

export const getCompanyInfo = id => (
  axios.get(routes.simuladores.getInfo(id))
);

export const calcularEconomia = params => (
  axios.post(routes.simuladores.calcularEconomia(), params)
);



// WEBPACK FOOTER //
// ./src/services/simulador.js